/* Chuyển tên trường giữa CSDL (snake_case) và giao diện (camelCase). */

// Các cột phụ cấp của nhân viên (a_lunch, a_fuel…) giữ nguyên tên vì logic lương đọc đúng các khóa này.
const KEEP = /^a_[a-z]+$/;

export const snakeToCamel = (k: string): string => (KEEP.test(k) ? k : k.replace(/_([a-z0-9])/g, (_, c: string) => c.toUpperCase()));
export const camelToSnake = (k: string): string => (KEEP.test(k) ? k : k.replace(/[A-Z]/g, c => '_' + c.toLowerCase()));

/** Chỉ đổi khóa ở tầng ngoài cùng; nội dung jsonb (items, cells, checks…) giữ nguyên như đã lưu. */
export function toCamel<T = Record<string, unknown>>(row: Record<string, unknown>): T {
  const out: Record<string, unknown> = {};
  for (const [k, v] of Object.entries(row)) out[snakeToCamel(k)] = v;
  return out as T;
}

export function toSnake(row: Record<string, unknown>): Record<string, unknown> {
  const out: Record<string, unknown> = {};
  for (const [k, v] of Object.entries(row)) if (v !== undefined) out[camelToSnake(k)] = v;
  return out;
}
